// src/routes/RequireCh1to3Complete.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

function readFlag(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw === "true" || raw === "1" || raw === true;
  } catch {
    return false;
  }
}

function isChapterDone(n) {
  const candidates = [
    `tt_ch${n}_done`,        // our canonical key
    `tt_chapter${n}_done`,   // tolerant legacy variants
    `tt_chapter_${n}_done`,
    `chapter-${n}-done`,
  ];
  return candidates.some(readFlag);
}

function hasFinishedChapter1to3() {
  return [1, 2, 3].every(isChapterDone);
}

export default function RequireCh1to3Complete({ children }) {
  const location = useLocation();
  if (!hasFinishedChapter1to3()) {
    // Helpful console so you can see what’s missing during dev
    console.warn("[RequireCh1to3Complete] Missing completion flags:", {
      ch1: isChapterDone(1), ch2: isChapterDone(2), ch3: isChapterDone(3)
    });
    return (
      <Navigate
        to="/chapter-1"
        replace
        state={{ from: location, reason: "finish_1_to_3_first" }}
      />
    );
  }
  return children;
}
